import { Cookies } from 'react-cookie';

const cookies = new Cookies();

const doesCookieExist = cookieName => Boolean(cookies.get(cookieName));

const getCookie = cookieName => cookies.get(cookieName);

const setCookie = (cookieName, expires = new Date(new Date().setYear(2099))) => {
  cookies.set(cookieName, true, {
    expires,
    path: '/',
  });
};

const unsetCookie = cookieName => cookies.remove(cookieName, { path: '/' });

export { doesCookieExist, setCookie, unsetCookie };
